var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM6.89985 13.2C6.89985 12.372 7.57185 11.7 8.39985 11.7C9.22785 11.7 9.89985 12.372 9.89985 13.2C9.89985 14.028 9.22785 14.7 8.39985 14.7C7.57185 14.7 6.89985 14.028 6.89985 13.2ZM14.0999 13.2C14.0999 12.372 14.7719 11.7 15.5999 11.7C16.4279 11.7 17.0999 12.372 17.0999 13.2C17.0999 14.028 16.4279 14.7 15.5999 14.7C14.7719 14.7 14.0999 14.028 14.0999 13.2ZM2.39985 12C2.39985 17.292 6.70785 21.6 11.9999 21.6C17.2919 21.6 21.5999 17.292 21.5999 12C21.5999 11.052 21.4559 10.14 21.2039 9.28801C20.3399 9.49201 19.4399 9.60001 18.5039 9.60001C14.4599 9.60001 10.8839 7.59601 8.71185 4.52401C7.53585 7.39201 5.29185 9.70801 2.45985 10.968C2.42385 11.304 2.39985 11.652 2.39985 12Z",
    fill: "#292F3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/student.f8391f4db24873da4bf7dfb7dcf4cd20.svg";
export { ForwardRef as ReactComponent };